import { HomePaths } from '@/modules/Paths';
import { useTranslate } from 'app/[locale]/hooks/useTranslate';
import clsx from 'clsx';
import analyticsInstance from 'libs/rtzr-commons/modules/marketing/Analytics';
import Image from 'next/image';
import Link from 'next/link';

type ProductSpec = {
  title: string;
  description: string;
  icon: string;
  href: string;
};

export const Product = ({ closePopover }: { closePopover?: () => void }) => {
  const { t } = useTranslate();

  const specs: Array<ProductSpec> = [
    {
      title: t.home.GNB_PRODUCT_MEET_TITLE,
      description: t.home.GNB_PRODUCT_MEET_DESC,
      icon: '/callabo/homepage/tool_meet.svg',
      href: HomePaths.Recording,
    },
    {
      title: t.home.GNB_PRODUCT_INTEGRATION_TITLE,
      description: t.home.GNB_PRODUCT_INTEGRATION_DESC,
      icon: '/callabo/homepage/tool_integration.svg',
      href: HomePaths.IntegrationsIndex,
    },
    {
      title: t.home.GNB_PRODUCT_AI_INSIGHT_TITLE,
      description: t.home.GNB_PRODUCT_AI_INSIGHT_DESC,
      icon: '/callabo/homepage/tool_ai_insight.svg',
      href: HomePaths.Insight,
    },
  ];

  return (
    <>
      {specs.map((spec, index) => (
        <OneProduct
          key={`product-${index}`}
          {...spec}
          closePopover={closePopover}
          className={index < specs.length - 1 && 'md:pb-5 md:border-b border-gray-ivory'}
        />
      ))}
    </>
  );
};

const OneProduct = ({
  title,
  description,
  icon,
  href,
  closePopover,
  className,
}: {
  title: string;
  description: string;
  icon: string;
  href: string;
  closePopover?: () => void;
  className?: string;
}) => {
  return (
    <Link href={href} passHref className={'w-full'}>
      <button
        onMouseDown={() => {
          analyticsInstance.logEvent('click_gnb_menu', {
            menu: href.split('/')[1],
          });
        }}
        onClick={closePopover}
        className="flex items-center gap-3.5 md:gap-5 w-full"
      >
        <div className="w-8 md:w-10 h-8 md:h-10 relative shrink-0 mb-5">
          <Image src={icon} className="shrink-0" fill alt="" sizes="40px" />
        </div>
        <div className={clsx('w-full', className)}>
          <p className="text-sm md:text-base mb-1 text-black-light font-semibold whitespace-nowrap">
            {title}
          </p>
          <span className="text-xs md:text-sm font-normal text-gray whitespace-nowrap">
            {description}
          </span>
        </div>
      </button>
    </Link>
  );
};
